import { synthTypes } from '../shared/constants';
import { SamplerNode } from './nodes/SamplerNode';
import { MultisamplerNode } from './nodes/MultisamplerNode';

const createSynthNode = (synth, note) => {
   switch (synth.type) {
      case synthTypes.sampler:
         return new SamplerNode(synth.presetData, note);
      case synthTypes.multisampler:
         return new MultisamplerNode(synth.presetData, note);
      default:
         return null;
   }
};

export { createSynthNode };
